var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "91px",
    viewBox: "0 0 118 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_Booked_re_vtod") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-29",
    transform: "translate(-224.000000, -412.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Booked_re_vtod",
    transform: "translate(224.000000, 412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ad541598-f069-4770-8bea-87004c1f5716",
    transform: "translate(64.000000, 68.000000)",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41832593,20.8246071 C4.40188148,20.7973737 4.0074163,20.1402526 3.87066519,18.7757258 C3.74533185,17.5239203 3.82587704,15.4138373 4.9221837,12.4704167 C6.99900444,6.89433549 4.44355704,2.39533099 4.4175037,2.35053592 L4.54357778,2.27752246 C5.03547207,3.21751391 5.39088269,4.22258937 5.59912444,5.26253197 C6.11383642,7.68416518 5.92642728,10.2020834 5.05886074,12.5211953 C2.9856563,18.087757 4.52698074,20.7228784 4.54275556,20.7488844 L4.41832593,20.8246071 Z",
    id: "f29270bb-d112-452d-932b-13393490bccd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "fcebc901-c108-48a2-87e5-7ddb6540303c",
    cx: 3.60628593,
    cy: 1.07772444,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "b5fd1405-e948-4f51-8090-73404e30ab37",
    cx: 6.59335407,
    cy: 4.56857662,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ac970879-223f-419f-9066-0afbab83f669",
    cx: 4.55334963,
    cy: 6.8958957,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "a05fe744-c6b8-499a-b570-83da982f4ab7",
    cx: 7.03048296,
    cy: 8.85954063,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "aa7e6742-c9e7-4b11-83e1-b132a19c1cd6",
    cx: 3.82480741,
    cy: 11.9140394,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99047556,20.8590649 C4.99047556,20.8590649 4.04332593,18.5318301 6.88469778,16.7863189 L4.99047556,20.8590649 Z",
    id: "b97b0dec-9dc3-4d20-978e-1db07813fbb6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82579259,20.8172231 C3.82579259,20.8172231 3.39474815,18.3424027 0.0585659259,18.3635683 L3.82579259,20.8172231 Z",
    id: "adf0fd01-34d6-447b-82cb-31f3ba0f5028"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16,19 C13.790861,19 12,17.209139 12,15 C12,12.790861 13.790861,11 16,11 C18.209139,11 20,12.790861 20,15 C20,17.209139 18.209139,19 16,19 L16,19 Z M16,11.1380484 C13.8670176,11.1380484 12.1378937,12.8671723 12.1378937,15.0001548 C12.1378937,17.1331372 13.8670176,18.8622611 16,18.8622611 C18.1329824,18.8622611 19.8621063,17.1331372 19.8621063,15.0001548 C19.8621063,13.9758596 19.4552108,12.9935161 18.7309247,12.26923 C18.0066387,11.544944 17.0242952,11.1380484 16,11.1380484 L16,11.1380484 Z",
    id: "ab4f3350-d584-452d-9eac-b0b73bd1c74e",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,19 C55.790861,19 54,17.209139 54,15 C54,12.790861 55.790861,11 58,11 C60.209139,11 62,12.790861 62,15 C62,17.209139 60.209139,19 58,19 L58,19 Z M58,11.1380484 C55.8670176,11.1380484 54.1378937,12.8671723 54.1378937,15.0001548 C54.1378937,17.1331372 55.8670176,18.8622611 58,18.8622611 C60.1329824,18.8622611 61.8621063,17.1331372 61.8621063,15.0001548 C61.8621063,13.9758596 61.4552108,12.9935161 60.7309247,12.26923 C60.0066387,11.544944 59.0242952,11.1380484 58,11.1380484 L58,11.1380484 Z",
    id: "b38c2432-9b55-44a1-a6c5-37f262cb8526",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.562017,9 L2.43798301,9 C1.09233307,9.00245768 0.00184230454,10.3503415 0,12.0138835 L0,44.9862701 C0.00184230454,46.6496585 1.09233307,47.9969279 2.43798301,48 L71.562017,48 C72.9076669,47.9976959 73.9981577,46.6498121 74,44.9862701 L74,12.0137299 C73.9981577,10.3503415 72.9076669,9.0030721 71.562017,9 L71.562017,9 Z M73.7135216,44.9862701 C73.7119864,46.4541194 72.7498428,47.6436364 71.562324,47.6453261 L2.43798301,47.6453261 C1.25046421,47.6434828 0.288627711,46.4541194 0.286785407,44.9862701 L0.286785407,12.0137299 C0.288167135,10.5458806 1.25046421,9.35636358 2.43798301,9.35467392 L71.562017,9.35467392 C72.7495358,9.35651718 73.7113723,10.5458806 73.7135216,12.0137299 L73.7135216,44.9862701 Z",
    id: "b9a1c0cd-2b1d-41a9-871b-afddc5e936af",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a89ccb60-c26f-4785-b3c5-3332740adbf1",
    fill: "#F2F2F2",
    x: 5,
    y: 23,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b7e05322-8b5b-4202-896a-d010557e20ee",
    fill: "#F2F2F2",
    x: 23,
    y: 23,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ad37576e-0400-4032-9a23-fea9f12fbce1",
    fill: "#F2F2F2",
    x: 40,
    y: 23,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "aa533c7f-257d-4f82-9a34-f3791ed05f8e",
    fill: "#F2F2F2",
    x: 56,
    y: 23,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ab695b59-e86b-4a87-812a-08bf740c05b4",
    fill: "#F2F2F2",
    x: 5,
    y: 36,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a6c88313-aaf4-41f2-8928-a742f49a0902",
    fill: "#F2F2F2",
    x: 23,
    y: 36,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f58c3339-a4c0-4d62-ba2a-e54ff2bf716d",
    fill: "#F2F2F2",
    x: 40,
    y: 36,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a422fb6a-8004-41fc-ab64-b502da5703c1",
    fill: "#F2F2F2",
    x: 56,
    y: 36,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e86106fc-25bd-447d-bb7e-e20bb3b23e30",
    fill: "#FEC532",
    points: "26.8517498 44 24 39.6971083 24.7767753 39.0827159 26.9597191 42.3762486 35.3129223 33 36 33.7308696"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "aa2d9f48-069a-485a-b75e-c70dd332b5e8",
    fill: "#FEC532",
    points: "44.8517498 31 42 26.6971083 42.7767753 26.0827159 44.9597191 29.3762486 53.3129223 20 54 20.7308696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "a17708df-8f3a-464e-8619-6278c337a09b",
    fill: "#2F2E41",
    x: 15.8948462,
    y: 0,
    width: 1,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e9aa34a1-352e-42c8-a0fd-7deef0e48a7e",
    fill: "#2F2E41",
    x: 57.8948462,
    y: 0,
    width: 1,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.773718,90.2095911 L59.226282,90.2095911 C59.1472685,90.2147645 59.071914,90.1759865 59.0308203,90.1090051 C58.9897266,90.0420237 58.9897266,89.9579763 59.0308203,89.8909949 C59.071914,89.8240135 59.1472685,89.7852355 59.226282,89.7904089 L117.773718,89.7904089 C117.852732,89.7852355 117.928086,89.8240135 117.96918,89.8909949 C118.010273,89.9579763 118.010273,90.0420237 117.96918,90.1090051 C117.928086,90.1759865 117.852732,90.2147645 117.773718,90.2095911 Z",
    id: "fc392f67-ef8a-4310-beff-ce5a3a27e5fb",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ba3ff805-5da2-4d08-bd39-7111d50a55d9",
    fill: "#FEC532",
    points: "9.85174978 31 7 26.6971083 7.77677527 26.0827159 9.95971913 29.3762486 18.3129223 20 19 20.7308696"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b4e7e83f-48c8-42d0-a802-1200052d292a",
    transform: "translate(90.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0225819,24.53509 C10.1004692,24.5105088 10.1800654,24.4924672 10.2606308,24.4811329 L13.4767148,17.5615619 L12.4948546,16.0030257 L14.522456,14.1266557 L17.0713861,17.4293903 L11.8799805,25.4293474 C12.1420612,26.0490003 12.0146194,26.7757214 11.5599214,27.2544451 C11.1052233,27.7331688 10.4181803,27.8639689 9.83447159,27.5829383 C9.25076292,27.3019078 8.8922289,26.6677074 8.93404411,25.9901984 C8.97585932,25.3126894 9.40929548,24.7332914 10.0225819,24.53509 Z",
    id: "bdecccf6-f579-4d39-b60a-bacda51b23df",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5123931,15.0837335 C15.4685566,15.1325683 15.4183066,15.1744639 15.3631903,15.2081302 L12.0727987,17.2278675 C11.7570355,17.4216615 11.3526898,17.3077215 11.1696665,16.973375 C11.1604706,16.9565814 11.1519497,16.939408 11.1441038,16.9218545 L9.54340448,13.3418706 C9.40264956,13.030497 9.49870933,12.6569308 9.76911776,12.4640958 L11.8087611,10.9949698 C12.071473,10.8057584 12.4241649,10.8412877 12.6484674,11.0795596 L15.4993276,14.1087768 C15.7517909,14.3766357 15.757386,14.8084899 15.5119569,15.0835811 L15.5123931,15.0837335 Z",
    id: "b851710e-73ca-4439-b312-82ecd7f1d520",
    fill: "#18683E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ad151a06-cd68-422d-8460-5ec9215ef0ce",
    fill: "#FFB8B8",
    points: "20.1323887 54.7306986 18.3951159 55.2312402 15.7451509 48.3738675 18.3092069 47.6351061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.01966,55.0622518 L20.3699119,54.0970416 L20.9437288,56.3301038 L15.4839711,57.9030654 C15.1669733,56.6694482 15.8544547,55.3973022 17.0195043,55.0616469 L17.0195131,55.0616469 L17.01966,55.0622518 Z",
    id: "a741d46f-b26c-45f0-81fb-c6a01d8961c3",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b643b79b-b2db-4e0a-a6b9-2a26cd7af685",
    fill: "#FFB8B8",
    points: "5.28098601 56.1343608 3.48041958 56.1343608 2.62382517 48.781267 5.28098601 48.781267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19456902,55.5895029 L5.66676483,55.5895029 L5.66676483,57.904527 L0.0083720979,57.904527 C0.0083720979,57.2905857 0.238627215,56.7017734 0.64859223,56.2676222 C1.05855724,55.8334709 1.61461101,55.5895441 2.19442804,55.5895029 L2.19456902,55.5895029 Z",
    id: "a8551279-f8d8-4e53-ac0b-f4d7d43df3e0",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ffb0ed30-f7ca-4f01-bb29-dfb3f0108b7e",
    fill: "#FFB8B8",
    cx: 7.17789105,
    cy: 4.73500804,
    rx: 3.60686014,
    ry: 3.81913673
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17070077,50.8916584 L2.71047,50.8916584 C2.36118639,50.8913574 2.07207528,50.6040748 2.04963084,50.2349989 C1.31653993,37.8946825 1.74535112,29.0426075 3.39921126,22.3774278 C3.40643652,22.3482592 3.41536273,22.319593 3.42593853,22.291594 L3.55810636,21.9428166 C3.65776783,21.6765 3.90126748,21.5019601 4.17180566,21.5029145 L9.23119028,21.5029145 C9.42414327,21.5029145 9.6075015,21.5920014 9.73298748,21.7472026 L10.4201134,22.5962107 C10.433477,22.6126932 10.4461064,22.6296423 10.4581483,22.6473688 C13.5567497,27.2229935 16.3338896,36.1683662 19.5501203,48.1919372 C19.6489008,48.5553006 19.4562182,48.9358257 19.1157287,49.0498085 L16.4723721,49.9457764 C16.158653,50.0503798 15.8198708,49.8961795 15.6756938,49.5831597 L8.8142742,34.5145109 C8.71575964,34.2982834 8.49507579,34.1759472 8.27112418,34.2134155 C8.04717257,34.2508838 7.87286105,34.4393048 7.84210636,34.6771597 L5.82551748,50.2866235 C5.77978153,50.632702 5.50072612,50.8905424 5.17070077,50.8916584 L5.17070077,50.8916584 Z",
    id: "fe8d7a91-2eb0-4840-bbb3-2ac5f6694a19",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1428502,22.6584091 L10.1221439,22.6584091 L3.97619287,22.4525324 C3.64959502,22.4429165 3.37902174,22.1812369 3.34046559,21.8377013 C2.56214392,15.1605485 4.69797608,13.3717227 5.65281524,12.9122321 C5.81506759,12.8346773 5.927157,12.6728699 5.94828378,12.4857066 L6.0309621,11.7859747 C6.04502988,11.6623581 6.09010918,11.5449869 6.16151455,11.4460605 C7.65853552,9.39273614 9.70258448,8.73514365 10.7873887,8.52615705 C11.1460484,8.45792226 11.4890404,8.71046941 11.5534834,9.09023737 C11.5554277,9.10171609 11.5571038,9.11324248 11.5585116,9.12481657 L11.6823088,10.1297871 C11.6949024,10.2256199 11.7310047,10.3162818 11.7870151,10.3927308 C14.9089662,14.714275 11.4310431,21.0950525 10.7020641,22.3303125 L10.7020641,22.3303125 C10.5811909,22.5340512 10.37008,22.6579121 10.1428502,22.6584091 L10.1428502,22.6584091 Z",
    id: "ac260d39-3f12-4112-9245-19e088f5ff96",
    fill: "#18683E"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b7ced118-7cfa-4844-a3c8-435a3db4f4e2",
    fill: "#FEC532",
    points: "8.20899692 31.0041675 3.56571483 31.9516511 3.38932364 30.9819953 6.9434635 30.2566299 2.81258434 18.7262159 3.68457483 18.3761182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.454905,5.16495598 C13.6502874,3.96532964 12.6854322,2.89576295 11.5905344,1.9897281 C10.6800449,1.23697206 9.66675818,0.593685201 8.54935259,0.286114155 C7.43194699,-0.0214568901 6.19691203,0.0307897587 5.17716378,0.604725416 C4.15741552,1.17866107 3.10286308,2.31906858 3.09636889,3.54188895 C3.09434559,3.93482729 3.18877217,4.46631255 3.5541428,4.3983608 L3.65987706,4.4139104 L6.30426168,3.84837153 L7.43047846,7.98705249 C7.50963231,8.27782997 7.61580713,8.60297206 7.87647147,8.72690236 C8.12200993,8.84367984 8.4051428,8.73358869 8.65479315,8.62380853 C8.69561832,8.60577099 9.04659734,7.77137957 9.04659734,7.77137957 C9.06450454,7.7182727 9.10816185,7.67959318 9.16068909,7.6702965 C9.21321633,7.66099983 9.2663804,7.68254316 9.29962531,7.72659673 L9.50815678,8.00260209 C9.58985986,8.11113269 9.72959203,8.14920025 9.85061832,8.09589968 L14.1631078,6.18967448 C14.3618001,6.10181925 14.5838421,5.98752971 14.6414085,5.7675029 C14.6957369,5.55587287 14.5741513,5.34315437 14.454905,5.16495598 Z",
    id: "a52cfa20-9d3d-49ed-8bbb-6f27952576f3",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56968972,32.1491061 C9.95188393,31.8652181 10.1957047,31.4166708 10.2355538,30.9241425 C10.275403,30.4316142 10.1071878,29.9456907 9.77616524,29.5971061 L10.9176548,15.0005431 L7.51888552,15.4956423 L7.45427014,29.6768755 C6.92551282,30.3183713 6.9338315,31.2773528 7.47362797,31.9084563 C8.01342444,32.5395598 8.91385353,32.6430415 9.56895545,32.1492616 L9.56968972,32.1491061 Z",
    id: "bd21c6a3-3a01-4e11-8b47-ec36a28067e7",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1398362,17.1023823 C11.0761995,17.1023823 11.0128921,17.0927109 10.9518642,17.0736155 L7.30315091,15.9372509 C7.13500711,15.8848855 6.99339595,15.7639388 6.9094704,15.6010177 C6.82554485,15.4380965 6.80617968,15.2465468 6.85563503,15.0685073 C6.8608072,15.0499006 6.86669895,15.0315475 6.87331028,15.0134477 L8.22362497,11.3197962 C8.33998404,10.9972633 8.66206167,10.8138083 8.98035923,10.8887614 L11.3909536,11.443571 C11.7013834,11.515056 11.9198464,11.8103126 11.9111075,12.1465684 L11.7989117,16.4214638 C11.789223,16.7997633 11.4972379,17.1013551 11.1398348,17.1022252 L11.1398362,17.1023823 Z",
    id: "b8799e3f-759a-46c3-9e68-c27b7b779f3b",
    fill: "#18683E"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.7e70e199efe6a92bfd837cecb659d042.svg";
export { ForwardRef as ReactComponent };